jQuery(function ($) {
  // Update custom CSS property to account for variable font size / zoom
  const readMoreHeight = $('.view-mode-tile__blurb-more').height() + 25;
  document.documentElement.style.setProperty('--tile-readmore-height', `${readMoreHeight}px`);
});
